<template>
	<div>
		<!-- 轮播图 -->
		<el-carousel height="55vh" :interval="5000" :autoplay="true">
			<el-carousel-item v-for="(item,index) in bannerList" :key="index">
				<el-image style="width: 100%;height: 100%" :src="item.src"></el-image>
				<div class="carousel-caption">
					<span>{{ item.title }}</span>
				</div>
			</el-carousel-item>
		</el-carousel>

		<!-- 主要产品 -->
		<div class="container">
			<div class="leftRight"></div>
			<section class="center">
				<div style="color: #4B4B4B;">
					<div class="module_title">产品</div>
					<div class="flex-between">
						<div class="product" v-for="item,index in productList" :key='"pro"+index' @click="goProduce(item.title)">
							<el-image style="width: 100%;height: 100%" :src="item.src"></el-image>
							<div class="title">{{item.title}}</div>
						</div>
					</div>
				</div>
			</section>
			<div class="leftRight"></div>
		</div>

		<!-- 解决方案 -->
		<div class="container solveplan">
			<div class="leftRight"></div>
			<section class="center">
				<div style="color: #4B4B4B;">
					<div class="module_title" style="margin: 0;color: #FFFFFF;">解决方案</div>
					<div class="flex-between" style="margin: 5px 0;color: #FFFFFF;">
						<div class="option" v-for="item in optionList" :key='item.title' @click="goOption(item.title)">
							<el-image :src="item.src" class="img"></el-image>
							<div class="name">{{item.title}}</div>
							<div class="line"></div>
							<div class="content">{{item.content}}</div>
						</div>
					</div>
				</div>
			</section>
			<div class="leftRight"></div>
		</div>

		<!-- 网络架构 -->
		<div class="container">
			<div class="leftRight"></div>
			<section class="center">
				<div style="color: #4B4B4B;">
					<div class="module_title">网络架构</div>
					<div class="network">
						<div class="flex_content" style="margin: -30px 0 20px;gap: 30px;">
							<el-radio v-model="radio" label="qqnet" class="title">
								<div>全球网络</div>
							</el-radio>
							<el-radio v-model="radio" label="qgnet" class="title">
								<div>全国网络</div>
							</el-radio>
						</div>
						<div v-if="radio == 'qqnet'">
							<el-image :src="wordMap" class="img"></el-image>
							<el-image :src="dataImg" class="imgData"></el-image>
						</div>
						<div v-else>
							<el-image :src="chinaMap" class="img"></el-image>
							<el-image :src="dataImg" class="imgData"></el-image>
						</div>
					</div>
				</div>
			</section>
			<div class="leftRight"></div>
		</div>

		<!-- 国内骨干 -->
		<div class="backbone">
			<el-image :src="chinapop" class="img"></el-image>
			<div class="title">
				国内骨干POP节点覆盖省份 <span style="color: #2D7AE4">20+</span>
			</div>
		</div>

		<!-- 服务支持 -->
		<div class="container" style="padding-bottom: 50px">
			<div class="leftRight"></div>
			<section class="center">
				<div style="color: #4B4B4B;">
					<div class="module_title">服务支持</div>
					<div class="flex-between" style="margin: 5px 0;">
						<div class="server" v-for="item in serverList" :key='item.sign'>
							<el-image :src="item.src" class="img"></el-image>
							<div class="name">{{item.name}}</div>
							<div class="content" style="">{{item.content}}</div>
						</div>
					</div>
				</div>
			</section>
			<div class="leftRight"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				bannerList: [
					{ title: '行 业 领 先 的 NaaS 服 务 商', src: require('@/assets/index/banner.jpg') },
					{ title: '安 全 生 态 · 连 接 世 界', src: require('@/assets/index/banner2.jpg') },
				],
				productList: [
					{ title: 'ZO-SASE', src: require('@/assets/index/zycp001.jpg') },
					{ title: 'ZO-Net', src: require('@/assets/index/zycp002.jpg') },
					{ title: 'ZO-Cloud', src: require('@/assets/index/zycp003.jpg') },
				],
				radio: 'qqnet',
				optionList: [
					{ title: 'ZO-SASE', src: require('@/assets/index/jjfa001.png'), content:'企业广域组网、SaaS加速、电商加速、5G双域加速' },
					{ title: 'ZO-Net', src: require('@/assets/index/jjfa002.png'), content:'企业专线组网、云连接、金融低时延连接、CDN回源电路' },
					{ title: 'ZO-Cloud', src: require('@/assets/index/jjfa003.png'), content:'全球加速云、金融算力云、外贸云' },
				],
				chinaMap: require('@/assets/index/chinamap.jpg'),
				wordMap: require('@/assets/index/wordmap.jpg'),
				dataImg: require('@/assets/index/data.jpg'),
				chinapop: require('@/assets/index/group.jpg'),
				serverList: [
					{ src: require('@/assets/index/ser1.png'),name: '尊享服务',content: '7*24*365运维保障响应' },
					{ src: require('@/assets/index/ser2.png'),name: 'SLA服务保障',content: '骨干网99.99%高可用性' },
					{ src: require('@/assets/index/ser3.png'),name: '备件升级',content: '合同服务期间免费升级备件' },
					{ src: require('@/assets/index/ser4.png'),name: '远程支持',content: '通过远程工具实时远程支持协助' },
				],
			}
		},
		mounted() {
			
		},
		methods: {
			goProduce(title) {
				this.$router.push({
					path:'/products',
					query:{
						name: title,
					}
      	})
			},
			goOption(title) {
				this.$router.push({
					path:'/solution',
					query:{
						name: title,
					}
      	})
			}
		},
	}
</script>

<style scoped  lang="scss">
.carousel-caption {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	text-align: center;
	color: #fff; /* 文字颜色 */
}
.carousel-caption span {
	font-size: 28px; /* 标题字体大小 */
	text-shadow: 2px 2px 2px #1A4169;
	// letter-spacing: 18px;
	// font-weight: bold;
	background-color: rgba(248, 242, 242, 0.2);
	backdrop-filter: blur(5px); /* 调整模糊程度 */
	// filter: blur(8px);// 模糊背景
	padding: 2px 16px 6px;
}

/* 圣杯布局 */
.container {
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  flex: 1;
}
.center {
  flex: 0 0 1200px;
}
.leftRight {
  flex: 1;
}

.solveplan {
	margin-top: 60px;
	height: 440px;
	display: flex;
	color: white;
  align-items: center;
  justify-content: center;
	background: url("../assets/index/solve.jpg") no-repeat;
  background-size: cover;// 全覆盖
	background-position: center; //指定元素背景图片的位置
}

.chinapop {
	height: 800px;
	background: url("../assets/index/group.jpg") no-repeat;
  background-size: cover;// 全覆盖
	background-position: center; //指定元素背景图片的位置
}

.backbone{
	margin-top: 50px;
	position: relative;
	.img {
		width: 100%;
	}
	.title {
		font-size: 28px;
  	font-weight: bold;
		color: #4B4B4B;
		text-align: center;
		position: absolute;
		top: 80px;
		left: 50%;
		transform: translate(-50%, -50%);
	}
}

// 标题
.module_title {
  font-size: 28px;
  font-weight: bold;
  color: #4B4B4B;
  text-align: center;
  margin: 30px 0 40px 0;
}

// 产品
.product {
	width: 320px;
	height: 200px;
	position: relative;
	.title {
		position: absolute;
		top: 88%;
		left: 50%;
		transform: translate(-50%, -50%);
		// background-color: rgba(248, 242, 242, 0.2);
		text-align: center;
		padding: 2px 16px 3px;
		font-size: 20px;
		color: white;
		font-weight: 500;
	}
}

// 解决方案
.option {
	margin: 0 50px;
	width: 25%;
	height: 240px;
	text-align: center;
	padding: 10px 20px 0;
	box-sizing: border-box;
	.img {
		height: 80px;
		margin: 30px 0 25px;
	}
	.name {
		font-size: 22px;
	}
	.line {
		width: 32px;
		height: 1px;
		background-color: rgb(161, 161, 161);
		margin: 20px auto;
	}
	.content {
		font-size: 14px;
		line-height: 18px;
	}
}

// 网络架构
.network {
	text-align: center;
	.imgname{
	 font-size: 22px;
	 margin: 15px 0 0;
	}
	.img {
		width: 100%;
	}
	.imgData {
		width: 68%;
	}
}

.server {
	width: 22%;
	height: 240px;
	background: linear-gradient(to bottom, #E5F3FF, white);
	border-radius: 10px;
	text-align: center;
	// box-sizing: border-box;
	.img {
		height: 80px;
		margin: 46px 0 20px;
	}
	.name {
		font-size: 22px;
		color: #2D79E4;
		font-weight: 600;
	}
	.content {
		margin-top: 6px;
		font-size: 14px;
		line-height: 22px;
		color: grey;
	}
}
</style>

<style scope>
.el-carousel__button {
	width: 10px;
	height: 10px;
	border-radius: 50%;
}

.el-avatar, .el-cascader-panel, .el-radio, .el-radio--medium.is-bordered .el-radio__label, .el-radio__label {
  font-size: 24px;
}
.el-radio__inner {
  display: none !important;
}
.el-radio-button:not(:last-child) {
	/* 最后一个不加间距 */
  margin-right: 60px; /* 适当的间距值 */
}
/* .el-radio-button__orig-radio:checked+.el-radio-button__inner {
	
} */
.el-radio-button:first-child .el-radio-button__inner {
	border: none;
}
.el-radio-button__inner{
	border: none;
	/* bborder-radius: 20px;
	padding: 8px 20px; */
	/* background-color: #EEF5FD; */
}
</style>
